import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { Box } from '@mui/system';
// import { CaySam } from 'src/types/caysam'; // Đã import gián tiếp qua LoSamPosition

// eslint-disable-next-line import/no-extraneous-dependencies
import QRCode from 'react-qr-code';
import { API_CONFIG } from 'src/constants';

// docx & file-saver
// eslint-disable-next-line import/no-extraneous-dependencies
import { 
    Document, 
    Packer, 
    Paragraph, 
    Table, 
    TableCell, 
    TableRow, 
    WidthType, 
    ImageRun, 
    TextRun,
    PageOrientation // 🌟 ĐÃ THÊM IMPORT NÀY 🌟
} from 'docx';

// eslint-disable-next-line import/no-extraneous-dependencies
import { saveAs } from 'file-saver';
import ReactDOMServer from 'react-dom/server';
import { LoSamPosition } from '../hooks/use-tracu';

type InMaQRPopupProps = {
  open: boolean;
  onClose: () => void;
  gridPositions: LoSamPosition[][]; // 2D array
  gridSize: { x: number; y: number };
  labelLot: string;
  // ❌ ĐÃ XÓA 'PageOrientation' KHỎI PROPS
};

// 🌟 ĐÃ XÓA 'PageOrientation' KHỎI DANH SÁCH THAM SỐ 🌟
export const InMaQRPopup = ({ open, onClose, gridPositions, gridSize, labelLot }: InMaQRPopupProps) => { 
  
  // ---------------------- Hàm xuất Word ----------------------
  const exportWord = async () => {
    // --------------------------------------------------------------------------------
    // ⚠️ LƯU Ý: Đảm bảo chuỗi SVG không chứa ký tự Unicode không phải Latin-1 trước khi dùng btoa().
    // Thư viện 'btoa' chuẩn trong trình duyệt không hỗ trợ UTF-8. 
    // Nếu gặp lỗi, bạn cần sử dụng một hàm mã hóa Base64 an toàn cho UTF-8.
    // --------------------------------------------------------------------------------
    
    const rows: TableRow[] = gridPositions.map(row => {
      const cells: TableCell[] = row.map(pos => {
        const {caySam} = pos;
        if (!caySam) {
          return new TableCell({
            width: { size: 2000, type: WidthType.DXA },
            children: [new Paragraph({ text: "Trống", alignment: "center" })],
          });
        }
        const urlQr = `${API_CONFIG.BASE_URL_QR}/${caySam?.caySam_ID ?? ''}`;
        
        // QR to SVG base64
        const svgString = ReactDOMServer.renderToStaticMarkup(<QRCode value={urlQr} size={100} />);
        const qrBase64 = `data:image/svg+xml;base64,${btoa(svgString)}`;

        return new TableCell({
          width: { size: 2000, type: WidthType.DXA },
          margins: {
            top: 100,
            bottom: 100,
            left: 100,
            right: 100,
          },
          children: [
            new Paragraph({
              children: [
                new ImageRun({
                  data: qrBase64,
                  transformation: {
                    width: 120,
                    height: 120,
                  },
                  type: "svg",
                  fallback: {
                    type: "png",
                    data: qrBase64,
                  },
                }),
              ],
              alignment: "center",
            }),
            new Paragraph({
              children: [new TextRun({ text: caySam.maCaySam, size: 16 })],
              alignment: "center",
            }),
          ],
        });
      });
      return new TableRow({ children: cells });
    });

    const doc = new Document({
      sections: [{
        properties: {
          page: {
           size: {
             // SỬ DỤNG PageOrientation ĐÃ IMPORT TRỰC TIẾP
             orientation: PageOrientation.LANDSCAPE, 
           },
          }
        },
        children: [
          new Paragraph({ text: `Lô: ${labelLot}`, heading: "Heading1" }),
          new Table({ rows }),
        ],
      }],
    });

    const blob = await Packer.toBlob(doc);
    saveAs(blob, `Lo_${labelLot}.docx`);
  };

  // ... (Phần còn lại của component JSX không đổi)
  // ...
  
  // ---------------------- JSX ----------------------
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
      <DialogTitle>In toàn bộ QR - Lô {labelLot}</DialogTitle>

      <DialogContent dividers>
        {gridPositions.map((row, y) => (
          <Grid container spacing={1} key={y} sx={{ mb: 1 }}>
            {row.map((pos, x) => {
              const middleColumn = Math.floor(gridSize.x / 2); // cột lối đi
              if (x === middleColumn) return null; // bỏ cột giữa
              const {caySam} = pos;
              const urlQr = `${API_CONFIG.BASE_URL_QR}/${caySam?.caySam_ID ?? ''}`;
              return (
                <Grid item xs={2} key={`${x}-${y}`}>
                  <Box
                    sx={{
                      borderRadius: 1,
                      p: 0.5,
                      width: { xs: 80, sm: 100, md: 160 },
                      height: { xs: 80, sm: 100, md: 160 },
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      backgroundColor: caySam ? '#e0f7fa' : '#fff',
                    }}
                  >
                    {caySam ? (
                      <>
                        <Box
                          sx={{
                            width: '100%',
                            height: '100%',
                            border: '1px dashed grey',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            mb: 0.5,
                          }}
                        >
                          <QRCode value={urlQr} size={120} />
                        </Box>
                        <Typography fontSize={10} noWrap>
                          {caySam.maCaySam}
                        </Typography>
                      </>
                    ) : (
                      <Typography fontSize={10} color="grey.400">
                        Trống
                      </Typography>
                    )}
                  </Box>
                </Grid>
              );
            })}
          </Grid>
        ))}
      </DialogContent>

      <DialogActions>
        <Button variant="outlined" onClick={onClose}>Đóng</Button>
        {/* <Button variant="contained" color="primary" onClick={handlePrintAll}>In tất cả</Button> */}
        <Button variant="contained" color="secondary" onClick={exportWord}>Xuất Word</Button>
      </DialogActions>
    </Dialog>
  );
};